function parseHex(color: string): [number, number, number] | null {
  const match = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(color);
  if (!match) return null;
  let hex = match[1];
  if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
  return [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16)) as [number, number, number];
}

const toHex = (value: number): string =>
  Math.round(Math.max(0, Math.min(255, value))).toString(16).padStart(2, '0');

/** Multiplies a hex colour's channels by `factor` (<1 darkens, >1 lightens). Non-hex input is returned unchanged. */
export function shadeColor(color: string, factor: number): string {
  const rgb = parseHex(color);
  if (!rgb) return color;
  return '#' + rgb.map(c => toHex(c * factor)).join('');
}

/** Mixes a hex colour towards white by `amount` (0..1). */
export function tintColor(color: string, amount: number): string {
  const rgb = parseHex(color);
  if (!rgb) return color;
  return '#' + rgb.map(c => toHex(c + (255 - c) * amount)).join('');
}

/** Converts a hex colour to an rgba() string. Non-hex input is returned unchanged. */
export function withAlpha(color: string, alpha: number): string {
  const rgb = parseHex(color);
  if (!rgb) return color;
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
}
